<template>
    <section :class="pageClass ? pageClass : 'HeroSection'" class="HeroSection">
        <div class="HeroWrapper container">
            <div class="HeroBody">
                <h1>{{title}}</h1>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: "HeroComponent",
        props: ['title', 'img', 'position', 'pageClass'],
        mounted() {
            let bacground = document.getElementsByClassName("HeroSection") || document.getElementsByClassName(this
                .pageClass)
            bacground[0].style.backgroundImage =
                `url(${require("@/assets/images/windowImage.png")}), url(${require(`@/assets/images/${this.img}`)}`
            bacground[0].style.backgroundPosition = `center, top ${this.position}% center`;
        }
    }
</script>

<style scoped lang="scss">
    .services {
        background-repeat: no-repeat;
        background-size: cover, 2200px;
        margin-top: -25px;

        .HeroWrapper {
            .HeroBody {
                padding: 178px 0;
                position: relative;

                h1 {
                    position: absolute;
                    font-size: 40px;
                    font-weight: 600;
                    color: #fff;
                    right: 0;
                    left: 0;
                    top: 135px !important;
                    text-align: center;
                }
            }
        }
    }

    .portafilo {
        background-repeat: no-repeat;
        background-size: cover, 2200px;
        margin-top: -25px;

        .HeroWrapper {
            .HeroBody {
                padding: 178px 0;
                position: relative;

                h1 {
                    position: absolute;
                    font-size: 40px;
                    font-weight: 500;
                    padding-top: 20px;
                    color: #fff;
                    right: 0;
                    left: 67px !important;
                    top: 140px !important;
                    text-align: center;
                }
            }
        }
    }

    .worklineAbout {
        background-repeat: no-repeat;
        background-size: cover, 2200px;
        margin-top: -25px;

        .HeroWrapper {
            .HeroBody {
                padding: 178px 0;
                position: relative;

                h1 {
                    position: absolute;
                    font-size: 36px !important;
                    font-weight: 500;
                    color: #fff;
                    right: 0;
                    left: 0px !important;
                    top: 158px !important;
                    text-align: center;
                }
            }
        }
    }

    .HeroSection {
        background-repeat: no-repeat;
        background-size: cover, 2200px;
        margin-top: -25px;

        .HeroWrapper {
            .HeroBody {
                padding: 178px 0;
                position: relative;

                h1 {
                    position: absolute;
                    font-size: 40px;
                    font-weight: 600;
                    padding-top: 20px;
                    color: #fff;
                    right: 0;
                    left: 0;
                    top: 160px;
                    text-align: center;
                }
            }
        }
    }

    @media only screen and (max-width: 860px) {
        .services {
            background-repeat: no-repeat;
            background-size: cover, 2200px;
            margin-top: -25px;

            .HeroWrapper {
                .HeroBody {
                    padding: 178px 0;
                    position: relative;

                    h1 {
                        position: absolute;
                        font-size: 40px;
                        font-weight: 600;
                        color: #fff;
                        right: 0;
                        left: 0;
                        top: 135px !important;
                        text-align: center;
                    }
                }
            }
        }

        .portafilo {
            background-repeat: no-repeat;
            background-size: cover, 2200px;
            margin-top: -25px;

            .HeroWrapper {
                .HeroBody {
                    padding: 178px 0;
                    position: relative;

                    h1 {
                        position: absolute;
                        font-size: 40px;
                        font-weight: 500;
                        padding-top: 20px;
                        color: #fff;
                        right: 0;
                        left: 67px !important;
                        top: 140px !important;
                        text-align: center;
                    }
                }
            }
        }

        .worklineAbout {
            background-repeat: no-repeat;
            background-size: cover, 2200px;
            margin-top: -25px;

            .HeroWrapper {
                .HeroBody {
                    padding: 178px 0;
                    position: relative;

                    h1 {
                        position: absolute;
                        font-size: 36px !important;
                        font-weight: 500;
                        color: #fff;
                        right: 0;
                        left: 0px !important;
                        top: 158px !important;
                        text-align: center;
                    }
                }
            }
        }

        .HeroSection {
            background-repeat: no-repeat;
            background-size: cover, 2200px;
            margin-top: -13px;

            .HeroWrapper {
                .HeroBody {
                    padding: 178px 0;
                    position: relative;

                    h1 {
                        position: absolute;
                        font-size: 30px;
                        font-weight: 600;
                        padding-top: 20px;
                        color: #fff;
                        right: 0;
                        left: 0;
                        top: 160px;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>